import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import ModalShell from "components/ModalShell";

export const WebsiteDialog = ({ open, onClose, website, onSubmit, isLoading }) => {
  const [name, setName] = useState("");
  const [domain, setDomain] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (website) {
      setName(website.name || "");
      setDomain(website.domain || "");
    } else {
      setName("");
      setDomain("");
    }
    setErrors({});
  }, [website, open]);

  const validate = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = "Name is required";
    } else if (name.length > 100) {
      newErrors.name = "Name must be less than 100 characters";
    }

    if (!domain.trim()) {
      newErrors.domain = "Domain is required";
    } else if (domain.length > 255) {
      newErrors.domain = "Domain must be less than 255 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    await onSubmit({ name: name.trim(), domain: domain.trim() });
  };

  return (
    <ModalShell
      open={open}
      onClose={onClose}
      title={website ? "Edit Website" : "Create New Website"}
      actions={
        <>
          <MDButton onClick={onClose} color="secondary" variant="text" disabled={isLoading}>
            Cancel
          </MDButton>
          <MDButton
            onClick={handleSubmit}
            color="info"
            variant="gradient"
            disabled={isLoading}
            startIcon={isLoading ? <CircularProgress size={16} color="inherit" /> : null}
          >
            {website ? "Update" : "Create"}
          </MDButton>
        </>
      }
    >
      <MDBox sx={{ pt: 1, display: "flex", flexDirection: "column", gap: 2.5 }}>
        <TextField
          autoFocus
          label="Website Name"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          error={!!errors.name}
          helperText={errors.name}
          placeholder="My Awesome Website"
          disabled={isLoading}
        />
        <TextField
          label="Domain"
          fullWidth
          value={domain}
          onChange={(e) => setDomain(e.target.value)}
          error={!!errors.domain}
          helperText={errors.domain}
          placeholder="example.com"
          disabled={isLoading}
        />
      </MDBox>
    </ModalShell>
  );
};

WebsiteDialog.defaultProps = {
  website: null,
  isLoading: false,
};

WebsiteDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  website: PropTypes.shape({
    website_id: PropTypes.string,
    name: PropTypes.string,
    domain: PropTypes.string,
  }),
  onSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

export default WebsiteDialog;
